import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Analytics from 'APP_ROOT/services/analytics';
import Events from '../../common/events';
import Validation from '../../common/validation';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import { strings } from '../../../localization';
import TagsTreeViewDropDown from '../../TagsTreeViewDropDown';
import { TAG_USER_ROLES } from '../../../data/tags';
import TagRolesDropDown from '../../TagRolesDropDown';

class ShareRavenModal extends Component {

    constructor(props) {

        super(props);

        this.state = {
            emailValid: true,
            formValid: false,
            selectedTag: undefined,
            selectedRole: TAG_USER_ROLES.GUEST,
            errorMessage: null,
        };
    }

    normalizeEmail = (email) => (email || '').trim().toLowerCase();

    afterShareRavenModalOpened = (e) => {
        Analytics.modalView('/shareRavenModal');
        this.setState({
            emailValid: true,
            formValid: false,
            errorMessage: null,
            selectedTag: undefined,
            selectedRole: TAG_USER_ROLES.GUEST,
        });
    }

    onShareSubmit = (e) => {

        e.preventDefault();
        if (this.validateForm()) {
            const tagName = this.props.tags.find(tag => tag.tagId === this.state.selectedTag).name;
            const targetEmail = this.normalizeEmail(this.shareTargetEmail.value);

            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.raven_invite_sending, targetEmail) } }));

            LambdaUtil.inviteUser(this.props.stage, tagName, this.state.selectedRole, targetEmail, this.onShareSuccess, this.onShareFail);

            this.setState({
                emailValid: true,
                formValid: true
            });
        } else {
            this.setState({
                emailValid: false,
                formValid: false,
            });
        }
    }

    validateForm() {

        const targetEmail = this.normalizeEmail(this.shareTargetEmail.value);

        if (!Validation.validateEmail(this.state.emailValid, targetEmail, true)) {
            this.setState({                
                errorMessage: strings.please_provide_a_valid_email_address
            });
            return false;
        }

        const userExists = Array.isArray(this.props.users) && this.props.users.find(
            user => user.email && this.normalizeEmail(user.email) === targetEmail
        );
        
        if (userExists) {
            const isAPendingInvite = !userExists.userId;
            this.setState({
                errorMessage: isAPendingInvite ? strings.formatString(strings.raven_invite_email_already_sent) : strings.formatString(strings.raven_invite_email_already_exists)
            });
            return false;
        }
        
        if(!this.state.selectedRole){
            this.setState({                
                errorMessage: strings.tags_please_select_a_role
            });
            return false;
        }
        
        if(!this.state.selectedTag){
            this.setState({                
                errorMessage: strings.formatString(strings.tags_please_select_a_tag, strings.user)
            });
            return false;
        } 


        return true;
    }

    onShareSuccess = (data) => {

        console.log(data);
        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR') {
            if (payload.message.indexOf('Unknown') > -1)
                this.genericError();
            else this.setState({
                errorMessage: payload.message
            });
            document.documentElement.classList.remove("no-scroll");
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        } else {
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.raven_invite_sent, this.normalizeEmail(this.shareTargetEmail.value)), style: 'success' } }));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }

    onShareFail = (data) => {

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.genericError(data);
    }

    onTagChange = ([selectedTag]) => {
        this.setState({selectedTag});
    }

    onRoleChange = (e) => {
        this.setState({selectedRole: e.target.value});
    }


    genericError(data) {

        if (data) console.error(data);
        this.setState({
            errorMessage: strings.formatString(strings.raven_invite_send_error)
        })
    }

    render() {
        const tagsAsAdmin = this.props.tags.filter(tag => tag.canEdit);
        return (
            <Modal 
                isOpen={this.props.shareRavenModalOpen}
                contentLabel="share-raven-modal"
                className="share-raven-modal react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                onAfterOpen={this.afterShareRavenModalOpened}>
                <div className="container-fluid form-card">
                    <h2><i className="material-icons">email</i> {strings.formatString(strings.raven_invite_title)}</h2>
                    <p>{strings.formatString(strings.raven_invite_message)}</p>
                    <p>{strings.formatString(strings.raven_invite_message2)}</p>
                    {!this.state.emailValid || this.state.errorMessage ? <p className="error-message"><i className="material-icons">error_outline</i>{this.state.errorMessage}</p> : null}
                    <form action="" onSubmit={this.onShareSubmit}>
                        <div className="row">
                            {/*  Email  */}
                            <div className="col-12 col-xl-4">
                                <div className='row'>
                                    <div className='col-12'>
                                        <h4>{strings.sign_in_email}</h4>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <input 
                                            id="shareTargetEmail" 
                                            type="email" 
                                            ref={(shareTargetEmail) => { this.shareTargetEmail = shareTargetEmail }} 
                                            placeholder="eg. raven@klashwerks.com"
                                            onBlur={e => {
                                                e.target.value = this.normalizeEmail(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                
                            </div>

                            {/* role  */}
                            <div className="col-4 col-xl-2">
                                <div className='row'>
                                    <div className='col-12'>
                                        <h4>{strings.tags_roles_list_label}</h4>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <TagRolesDropDown
                                             showOptionForAll={false}
                                             value={this.state.selectedRole}
                                             onChange={this.onRoleChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* tags */}
                            <div className="col-8 col-xl-6">
                                <div className='row'>
                                    <div className='col-12'>
                                        <h4>{strings.tags_list_select_tag_label}</h4>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className='col-12'>
                                        <TagsTreeViewDropDown
                                            tags={tagsAsAdmin}
                                            placeholder={strings.tags_list_select_tag_placeholder}
                                            multipleSelection={false}
                                            selectedTagsIds={this.state.selectedTag ? [this.state.selectedTag] : []}
                                            onChange={this.onTagChange}
                                            compact
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 action-btns text-right">
                                <button className="btn btn-outline-blue" onClick={this.props.closeShareRavenModal} type="button"><i className="material-icons">close</i>{strings.formatString(strings.app_cancel)}</button>
                                <button className="btn" type="submit"><i className="material-icons">email</i>{strings.formatString(strings.raven_invite_send)}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        );
    }
}

ShareRavenModal.propTypes = {
    tags: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired, // full/original list
    stage: PropTypes.string.isRequired,
    shareRavenModalOpen: PropTypes.bool.isRequired,
    closeShareRavenModal: PropTypes.func.isRequired,
};

export default ShareRavenModal;